import { createSelector } from 'reselect'
import { AppNavigationState, StateWithAppNavigation } from './types'

// Base selectors
export const selectAppNavigation = (
  state: StateWithAppNavigation
): AppNavigationState => state.appNavigation

export const selectAppNavigationMain = createSelector(
  [selectAppNavigation],
  appNavigation => appNavigation.main
)

// Memoized form state selectors using createSelector
export const selectIsFormValid = createSelector(
  [selectAppNavigationMain],
  main => main.isFormValid
)

export const selectIsConfirmModalVisible = createSelector(
  [selectAppNavigationMain],
  main => main.isConfirmModalVisible
)
